<div class="igo-search-bar-container" [ngClass]="{ empty: empty$ | async }">
  <mat-form-field [floatLabel]="floatLabel()" [appearance]="appearance()">
    @if (label()) {
      <mat-label>{{ label() }}</mat-label>
    }
    <input
      #input
      matInput
      autocomplete="off"
      [ngClass]="{ hasSearchIcon: showSearchButton }"
      [disabled]="disabled$ | async"
      [placeholder]="
        placeholder()
          ? placeholder()
          : (placeholder$ | async)
            ? (placeholder$.value | translate)
            : undefined
      "
      [value]="term$ | async"
      (keyup)="onKeyup($event)"
    />
    @if ((empty$ | async) === false) {
      <button
        mat-icon-button
        matSuffix
        [color]="color()"
        (click)="onClearButtonClick()"
        [matTooltip]="'igo.geo.search.clearSearch' | translate"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  @if (withDivider()) {
    <mat-divider [vertical]="true" />
  }

  <div class="search-bar-buttons">
    @if (showSearchButton) {
      <button mat-icon-button [color]="color()" (click)="handleSearch()">
        <mat-icon>search</mat-icon>
      </button>
    }

    @if (searchSelector()) {
      <igo-search-selector
        [searchTypes]="searchTypes()"
        [searchType]="searchType$ | async"
        (searchTypeChange)="onSearchTypeChange($event)"
      />
    }

    @if (searchSettings()) {
      <igo-search-settings
        [pointerSummaryEnabled]="pointerSummaryEnabled()"
        [allowResetSearchSourcesOptions]="allowResetSearchSourcesOptions()"
        (pointerSummaryStatus)="pointerSummaryStatus.emit($event)"
        [searchResultsGeometryEnabled]="searchResultsGeometryEnabled()"
        (searchResultsGeometryStatus)="searchResultsGeometryStatus.emit($event)"
        [reverseSearchCoordsFormatEnabled]="reverseSearchCoordsFormatEnabled"
        (reverseSearchCoordsFormatStatus)="
          reverseSearchCoordsFormatStatus.emit($event)
        "
        (searchSourceChange)="onSearchSettingsChange()"
      />
    }
  </div>
</div>
